import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
const steps = [{
  title: 'Fase de Apertura',
  description: 'Inicias el sábado con el Brebaje de Cortisol para apagar la señal de alerta.'
}, {
  title: 'Ventana de Limpieza',
  description: 'Aplicas el Micro-Ayuno del domingo para que tus células eliminen deshechos.'
}, {
  title: 'Mantenimiento Local',
  description: 'Sigues la lista de compra USA para que el lunes sea tu primer día de una nueva vida.'
}];
export function HowItWorks() {
  return <SectionWrapper className="bg-brand-cream" data-id="element-66">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67">
        <div className="text-center mb-16" data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-69">
            Cómo funciona el protocolo
          </h2>
          <p className="text-xl text-gray-600" data-id="element-70">
            3 pasos simples para tu fin de semana de reseteo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-71">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-brand-teal/20 z-0" data-id="element-72"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-73">
              <div className="w-24 h-24 rounded-full bg-white border-4 border-brand-teal flex items-center justify-center text-3xl font-bold text-brand-teal mb-6 shadow-lg" data-id="element-74">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-75">
                {step.title}
              </h3>
              <p className="text-gray-600 text-lg" data-id="element-76">{step.description}</p>
            </div>)}
        </div>
      </div>
    </SectionWrapper>;
}